import { create } from 'zustand';

const state = {
    selectedAuditTrail: false,
    isOpenDetailModal: false,
    isOpenHelpModal: false,
    selectedExportAuditTrail: [],
};

export const useMainState = create((set) => ({
    ...state,
    onChangeMainState: (newState) => set((state) => ({ ...state, ...newState })),
    resetMainState: () => set(() => ({ ...state })),
}));
